import { reduxForm } from 'redux-form';
import { I18n } from 'react-redux-i18n';


const FORM_NAME = 'FlowForm';


const FORM_DEFINITION = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  fields: ['name', 'userIdCreated', 'dateCreated'],
  initialValues: {
    dateCreated: new Date(),
  },
  validate: (values) => {


    const errors = {};
    const requiredFields = ['name'];
    requiredFields.forEach((field) => {

      if (values[field] == null) errors[field] = I18n.t('messages.required_field');


    });
    return errors;

  },
});

export {
  FORM_NAME,
  FORM_DEFINITION,
};



// WEBPACK FOOTER //
// ./src/components/tracker/Flow/index.js